<template lang="pug">
#maintenance
  #pc.d-flex.align-items-center.justify-content-center(v-if="appmode == 'pc'")
    .box.box-margin
      .box-body.p-4
        .maintenance-message.mb-3
          .message ご不便をおかけして申し訳ありません。
          .message ただいまシステムメンテナンス中です。
        .period(v-if="_showMaintenance")
          .title メンテナンス期間
          .times(v-if="maintenance") {{ _start }} ～ {{ _end }}
        .messages.mb-3
          .message メンテナンス終了までしばらくお待ちください。
        .buttons
          button.btn.btn-default-style.logout-btn(@click="logout()") ログイン画面へ

  #mobile(v-if="appmode == 'mobile'")
    .p-4
      .messages.mb-3
        .message ご不便をおかけして申し訳ありません。
        .message ただいまシステムメンテナンス中です。
      .title メンテナンス期間
      .times.mb-3(v-if="maintenance") {{ _start }} ～ {{ _end }}
      .messages.mb-3
        .message メンテナンス終了までしばらくお待ちください。

      b-btn.btn.logout-btn(@click="logout()") ログイン画面へ
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore, systemSettingStore } from "@/store/store";

import { Url } from "@/commons/constants/Url";
import SystemSettingsService, { SystemSetting, MaintenanceModel } from "@/commons/services/SystemSettings";

/**
 * ### メンテナンス画面コンポーネント
 */
@Component
export default class Maintenance extends Vue {
  /** システム設定サービス */
  @Inject("SystemSettingsService") systemSettingsService!: SystemSettingsService;

  /** アプリモード。storeのgetterから値を取得する */
  @Getter("appMode") appmode!: string;

  /** メンテナンス */
  maintenance: MaintenanceModel | null = null;

  /**
   * ### vue lifecycle created
   *
   * - storeのログアウト処理を呼び出し、セッション破棄を行う
   *   - セッション破棄を行うことで、戻るボタンを押下してもログイン画面へ遷移させることができる
   * - システム設定情報を更新して、メンテナンス中でなければログイン画面へ遷移する
   */
  public async created(): Promise<void> {
    userStore.logout();

    // システム設定情報を更新して、メンテナンスが終わっていればログイン画面へ遷移する
    const sytemSetting: SystemSetting = await this.getSystemSetting();
    if (sytemSetting.maintenance.status == false) {
      this.$router.push(Url.Root);
      return;
    }

    this.maintenance = sytemSetting.maintenance;

    return;
  }

  /**
   * ### システム設定を取得する
   */
  public async getSystemSetting(): Promise<SystemSetting> {
    const systemSetting: SystemSetting = await systemSettingStore.updateSystemSetting({
      systemSettingsService: this.systemSettingsService
    });
    return systemSetting;
  }

  /**
   * ### メンテナンス期間を表示するかを取得する
   */
  get _showMaintenance(): boolean {
    if (this.maintenance && (!this.maintenance.start || !this.maintenance.end)) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * ### メンテナンス開始日時を取得する
   */
  get _start(): string {
    let start: string = "－";
    if (this.maintenance && this.maintenance.start) {
      start = this.$dateUtil.convertNumberToString(this.maintenance.start, "yyyy年mm月dd日 hh:MM");
    }
    return start;
  }

  /**
   * ### メンテナンス終了日時を取得する
   */
  get _end(): string {
    let end: string = "－";
    if (this.maintenance && this.maintenance.end) {
      end = this.$dateUtil.convertNumberToString(this.maintenance.end, "yyyy年mm月dd日 hh:MM");
    }
    return end;
  }

  /**
   * ### ログイン画面へ遷移する
   */
  public logout(): void {
    this.$router.push(Url.Root);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

#maintenance {
  #pc {
    height: 100vh;
    width: 100vw;
    background-color: $bg-gray !important;

    .box {
      width: 500px;
      margin-left: auto;
      margin-right: auto;

      .box-body {
        .maintenance-message {
          font-size: 1.4rem;
        }
        .period {
          margin-bottom: 20px;
          .title {
            font-size: 1.4rem;
            font-weight: bold;
          }
          .times {
            font-size: 1.2rem;
          }
        }
        .messages {
          font-size: 1.1rem;
        }
        .buttons {
          .logout-btn {
            min-width: 160px;
          }
        }
      }
    }
  }

  #mobile {
    background-color: $bg-default !important;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 1.1rem;
      font-weight: bold;
    }
    .times {
      font-size: 0.95rem;
    }
  }
}
</style>
